import { render, staticRenderFns } from "./ServiceSliderSelector.vue?vue&type=template&id=4221c95e&scoped=true&"
import script from "./ServiceSliderSelector.vue?vue&type=script&lang=ts&"
export * from "./ServiceSliderSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4221c95e",
  null
  
)

export default component.exports